
module.exports = require('./formatters');



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsondiffpatch/src/main-formatters.js
 ** module id = 437
 ** module chunks = 0
 **/